import styles from './PageSkeleton.module.css';

interface PageSkeletonProps {
  variant?: 'manager' | 'settings' | 'processing';
}

export function PageSkeleton({ variant = 'manager' }: PageSkeletonProps) {
  if (variant === 'settings') {
    return (
      <div className={styles.page}>
        <div className={styles.settingsLayout}>
          <div className={styles.settingsNav}>
            {Array.from({ length: 6 }, (_, i) => (
              <div key={i} className={`mc-skeleton ${styles.navItem}`} />
            ))}
          </div>
          <div className={styles.settingsContent}>
            <div className={`mc-skeleton ${styles.heading}`} />
            {Array.from({ length: 3 }, (_, i) => (
              <div key={i} className={styles.fieldGroup}>
                <div className={`mc-skeleton ${styles.label}`} />
                <div className={`mc-skeleton ${styles.input}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'processing') {
    return (
      <div className={styles.page}>
        <div className={styles.header}>
          <div className={`mc-skeleton ${styles.heading}`} />
          <div className={`mc-skeleton ${styles.button}`} />
        </div>
        <div className={styles.badges}>
          {Array.from({ length: 4 }, (_, i) => (
            <div key={i} className={`mc-skeleton ${styles.badge}`} />
          ))}
        </div>
        <div className={styles.logLines}>
          {Array.from({ length: 8 }, (_, i) => (
            <div key={i} className={`mc-skeleton ${styles.logLine}`} />
          ))}
        </div>
      </div>
    );
  }

  // Default: manager skeleton
  return (
    <div className={styles.page}>
      <div className={styles.toolbar}>
        <div className={`mc-skeleton ${styles.searchBar}`} />
        <div className={`mc-skeleton ${styles.button}`} />
        <div className={`mc-skeleton ${styles.button}`} />
      </div>
      <div className={styles.list}>
        {Array.from({ length: 10 }, (_, i) => (
          <div key={i} className={styles.listItem}>
            <div className={`mc-skeleton ${styles.favicon}`} />
            <div className={styles.listContent}>
              <div className={`mc-skeleton ${styles.titleLine}`} />
              <div className={`mc-skeleton ${styles.metaLine}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
